import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {Paperclip, Xmark} from '@gravity-ui/icons';
import {Button, Link, Loader} from '@gravity-ui/uikit';
import i18n from 'ui/i18n';

import {FileBadgeProps} from './FileBadge.types';

import './FileBadge.scss';

const cnFileBadge = cn('FileBadge');

const FileBadge: FC<FileBadgeProps> = ({name, onDelete, loading, url}) => {
    return (
        <div className={cnFileBadge()}>
            {loading && <Loader size="s" className={cnFileBadge('Loader')} />}
            <div className={cnFileBadge('Info', {loading})}>
                <Paperclip className={cnFileBadge('Paperclip')} />
                {url ? (
                    <Link className={cnFileBadge('Name')} href={url} target="_blank">
                        {name}
                    </Link>
                ) : (
                    <span className={cnFileBadge('Name')}>{name}</span>
                )}
            </div>
            <Button
                onClick={onDelete}
                size="s"
                view="flat"
                className={cnFileBadge('Delete')}
                title={i18n('survey-page', 'delete-selected-btn')}
            >
                <Button.Icon>
                    <Xmark aria-hidden="true" focusable="false" />
                </Button.Icon>
            </Button>
        </div>
    );
};
export default FileBadge;
